import { useState } from 'react'
import { find, get, isEmpty } from 'lodash'
import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import * as Yup from 'yup'

import { useAppSelector } from 'src/store/index'
import { answerInterView } from 'src/useCase/question'
import { useAppDispatch } from 'src/store'
import LocalStorage from 'src/utils/LocalStorage'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'

export type AnswerInterface = {
  answer: any
  question_id: number
  question_type: string
}

export type FormValues = {
  answers: AnswerInterface[]
  reservation_id: string
  menu_id: string | number
  user_treatment_id?: string | number
}

export type QForm = {
  '1': null
  '2': null
  '3': null
  '4': []
  '5': null
  '6': null
  '7': null
  '8': null
  '9': null
  '10': null
  '11': null
  '12': null
  '13': null
  '14': null
}

export const useQuestionForm = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const questions = useAppSelector(
    (state) => state.domain.automaticPlan.questions.entity,
  )
  const [errorData, setErrorsData] = useState({})

  let answersList = {} as any
  questions &&
    questions.length > 0 &&
    questions.forEach((question) => {
      const id = String(question.id)
      const dataAnswer = get(question, 'draftAnswer.0')
      const questionType = question.type

      if (dataAnswer) {
        answersList[id] =
          questionType === 'radio'
            ? get(dataAnswer, 'answers.0', null)
            : dataAnswer.answers
      } else {
        // Ensure every question has a default value to prevent uncontrolled to controlled warning
        answersList[id] = questionType === 'checkbox' ? [] : null
      }
    })

  const defaultValues: QForm = answersList

  const validationSchema = Yup.object().shape({})

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    let errorDataValue = {} as any
    if (questions) {
      questions.forEach((question) => {
        const questionValue = find(
          data.answers,
          (data) => data.question_id === question.id,
        )

        const idName: any = question.id.toString()
        const questionBeforeValue = find(
          data.answers,
          (data) => data.question_id === Number(idName) - 1,
        )

        const prevAnswer = get(questionBeforeValue, 'answer.0.value')
        const currAnswer = get(questionValue, 'answer.0.value')
        const isRequired = question.required

        if (question.type === 'textarea') {
          if (!currAnswer) {
            if (prevAnswer !== 'なし' && isRequired) {
              form.setError(idName, {
                type: 'custom',
                message: '入力してください',
              })
              errorDataValue = { ...errorDataValue, [idName]: idName }
            } else {
              if (prevAnswer !== 'なし' && isRequired) {
                form.setError(idName, {})
                errorDataValue = { ...errorDataValue, [idName]: idName }
              }
            }
          }
        } else {
          const noAnswer =
            !questionValue ||
            (questionValue && questionValue.answer.length === 0) ||
            (questionValue &&
              questionValue.question_type === 'input' &&
              !get(questionValue, 'answer.0.value'))

          if (noAnswer && isRequired) {
            form.setError(idName, {
              type: 'custom',
              message: '選択してください。',
            })
            errorDataValue = { ...errorDataValue, [idName]: idName }
          }
        }
      })
      setErrorsData(errorDataValue)
    }

    if (!isEmpty(errorDataValue)) {
      return false
    }

    try {
      const userTreatmentId =
        data.user_treatment_id || LocalStorage.getUserTreatmentId()
      await dispatch(
        answerInterView({
          answers: data.answers,
          reservation_id: data.reservation_id,
          user_treatment_id: Number(userTreatmentId),
          menu_id: data.menu_id,
          from: location.pathname,
          params: qs.parse(location.search),
        }),
      ).unwrap()
      return true
    } catch (err) {
      return false
    }
  }

  const onValidateForm = (data) => {
    form.clearErrors()
    const errorIds: string[] = []

    if (questions) {
      for (const question of questions) {
        const questionValue = find(
          data.answers,
          (d) => d.question_id === question.id,
        )

        const idName: any = String(question.id)
        const isRequired = question.required
        const currAnswer = get(questionValue, 'answer.0.value')

        const noAnswer =
          !questionValue ||
          questionValue.answer?.length === 0 ||
          (questionValue.question_type === 'input' && !currAnswer)

        if (
          (question.type === 'textarea' && !currAnswer && isRequired) ||
          (noAnswer && isRequired)
        ) {
          form.setError(idName, {
            type: 'custom',
            message:
              question.type === 'textarea'
                ? '入力してください'
                : '選択してください。',
          })

          errorIds.push(idName)
        }
      }
    }

    const errorDataValue = Object.fromEntries(errorIds.map((id) => [id, id]))
    setErrorsData(errorDataValue)

    if (errorIds.length > 0) {
      return {
        valid: false,
        firstErrorId: errorIds[0],
      }
    }

    return { valid: true, firstErrorId: null }
  }

  const form = useForm<QForm>({
    defaultValues,
    shouldFocusError: true,
    mode: 'all',
    resolver: yupResolver(validationSchema),
  })

  return {
    form,
    onSubmit,
    errorData: errorData,
    onValidateForm,
  }
}
